import React, { useEffect, useState } from "react";
import { Checkbox, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { PURPLE } from "../../styles/styleUtils";
import { applyROAccess } from "../../utils/ValidationUtils";
import { getTranslated } from "../../utils/CommonUtils";
import { useSelector } from "react-redux";

/**
 * @param {*} props 
 * @param {String} props.type either STRING or BOOLEAN. Default BOOLEAN
 * @param {any} props.value Value of the item. Could be either 'type' as STRING [Yes | No] or BOOLEAN [true | false]
 * @returns {React.ReactNode} returns a reactNode to Checkbox
 */
const UMCCheckbox = (props) => {
  const [value, setValue] = useState(null)
  const [readOnly, setReadOnly] = useState(false)
  const dict = useSelector(state => state.common.dict)

  useEffect(() => {
    if (value === null && props.value === undefined) {
      // setValue(props.type === "STRING" ? handleTypeString(props.defaultValue) : String(props.defaultValue).toLowerCase() === "true" ? true : false)
      setValue(handleTypeString(props.defaultValue))

      props.handleSchemaDataChange && props.handleSchemaDataChange(props, props.defaultValue)
    } else {
      // setValue(props.type === "STRING" ? handleTypeString(props.value) : String(props.value).toLowerCase() === "true" ? true : false)
      setValue(handleTypeString(props.value))
    }
  }, [props.value, props.defaultValue])

  useEffect(() => {
    setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
  }, [props.access, props.actionMode, props.isReadOnly])


  const handleTypeString = (value) => {
    if(props.type === "STRING")
      return value === "Yes" ? true : false
    else 
      return String(value).toLowerCase() === "true" ? true : false
  }

  const handleReverseTypeString = (value) => {
    if(props.type === "STRING")
      return value === true ? "Yes" : "No"
    else 
      return value
  }

  const handleChange = (event) => {
    setValue(event?.target?.checked)
    props.handleChange && props.handleChange(handleReverseTypeString(event?.target?.checked))
    props.handleSchemaDataChange && props.handleSchemaDataChange(props, handleReverseTypeString(event?.target?.checked))
  }


  return <div className={props.className}>
    <Checkbox
      onChange={(event) => handleChange(event)}
      checked={value}
      disabled={readOnly}
    >
      {getTranslated(dict,  props.label)}
      {props.help ? <Tooltip title={getTranslated(dict, props.help)}><InfoCircleFilled style={{ color: PURPLE, paddingLeft: "5px" }} /></Tooltip> : <></>}
    </Checkbox>
  </div>
}

export default UMCCheckbox